export default __webpack_public_path__ + "static/media/geo.c8e45a54.jpg";